import { render, staticRenderFns } from "./FinalProductTableRow.vue?vue&type=template&id=cb8dc166&scoped=true&lang=pug"
import script from "./FinalProductTableRow.vue?vue&type=script&lang=js"
export * from "./FinalProductTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb8dc166",
  null
  
)

export default component.exports